/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app/route'
import { Route as LandingIndexImport } from './routes/_landing/index'
import { Route as AppWIndexImport } from './routes/_app/w.index'
import { Route as AppWSlugRouteImport } from './routes/_app/w.$slug/route'
import { Route as AppWSlugIndexImport } from './routes/_app/w.$slug/index'
import { Route as AppWSlugSettingsRouteImport } from './routes/_app/w.$slug/settings/route'
import { Route as AppWSlugBoardKeyRouteImport } from './routes/_app/w.$slug/$boardKey/route'
import { Route as AppWSlugSettingsIndexImport } from './routes/_app/w.$slug/settings/index'
import { Route as AppWSlugBoardKeyIndexImport } from './routes/_app/w.$slug/$boardKey/index'
import { Route as AppWSlugBoardKeyTaskNumberImport } from './routes/_app/w.$slug/$boardKey/$taskNumber'
import { Route as AppWSlugSettingsBoardsBoardIdRouteImport } from './routes/_app/w.$slug/settings/boards/$boardId/route'
import { Route as AppWSlugSettingsBoardsBoardIdIndexImport } from './routes/_app/w.$slug/settings/boards/$boardId/index'
import { Route as AppWSlugSettingsBoardsBoardIdListsImport } from './routes/_app/w.$slug/settings/boards/$boardId/lists'

// Create/Update Routes

const AppRouteRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const LandingIndexRoute = LandingIndexImport.update({
  id: '/_landing/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppWIndexRoute = AppWIndexImport.update({
  id: '/w/',
  path: '/w/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppWSlugRouteRoute = AppWSlugRouteImport.update({
  id: '/w/$slug',
  path: '/w/$slug',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppWSlugIndexRoute = AppWSlugIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWSlugRouteRoute,
} as any)

const AppWSlugSettingsRouteRoute = AppWSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppWSlugRouteRoute,
} as any)

const AppWSlugBoardKeyRouteRoute = AppWSlugBoardKeyRouteImport.update({
  id: '/$boardKey',
  path: '/$boardKey',
  getParentRoute: () => AppWSlugRouteRoute,
} as any)

const AppWSlugSettingsIndexRoute = AppWSlugSettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWSlugSettingsRouteRoute,
} as any)

const AppWSlugBoardKeyIndexRoute = AppWSlugBoardKeyIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWSlugBoardKeyRouteRoute,
} as any)

const AppWSlugBoardKeyTaskNumberRoute = AppWSlugBoardKeyTaskNumberImport.update(
  {
    id: '/$taskNumber',
    path: '/$taskNumber',
    getParentRoute: () => AppWSlugBoardKeyRouteRoute,
  } as any,
)

const AppWSlugSettingsBoardsBoardIdRouteRoute =
  AppWSlugSettingsBoardsBoardIdRouteImport.update({
    id: '/boards/$boardId',
    path: '/boards/$boardId',
    getParentRoute: () => AppWSlugSettingsRouteRoute,
  } as any)

const AppWSlugSettingsBoardsBoardIdIndexRoute =
  AppWSlugSettingsBoardsBoardIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppWSlugSettingsBoardsBoardIdRouteRoute,
  } as any)

const AppWSlugSettingsBoardsBoardIdListsRoute =
  AppWSlugSettingsBoardsBoardIdListsImport.update({
    id: '/lists',
    path: '/lists',
    getParentRoute: () => AppWSlugSettingsBoardsBoardIdRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/_landing/': {
      id: '/_landing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LandingIndexImport
      parentRoute: typeof rootRoute
    }
    '/_app/w/$slug': {
      id: '/_app/w/$slug'
      path: '/w/$slug'
      fullPath: '/w/$slug'
      preLoaderRoute: typeof AppWSlugRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/w/': {
      id: '/_app/w/'
      path: '/w'
      fullPath: '/w'
      preLoaderRoute: typeof AppWIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/w/$slug/$boardKey': {
      id: '/_app/w/$slug/$boardKey'
      path: '/$boardKey'
      fullPath: '/w/$slug/$boardKey'
      preLoaderRoute: typeof AppWSlugBoardKeyRouteImport
      parentRoute: typeof AppWSlugRouteImport
    }
    '/_app/w/$slug/settings': {
      id: '/_app/w/$slug/settings'
      path: '/settings'
      fullPath: '/w/$slug/settings'
      preLoaderRoute: typeof AppWSlugSettingsRouteImport
      parentRoute: typeof AppWSlugRouteImport
    }
    '/_app/w/$slug/': {
      id: '/_app/w/$slug/'
      path: '/'
      fullPath: '/w/$slug/'
      preLoaderRoute: typeof AppWSlugIndexImport
      parentRoute: typeof AppWSlugRouteImport
    }
    '/_app/w/$slug/$boardKey/$taskNumber': {
      id: '/_app/w/$slug/$boardKey/$taskNumber'
      path: '/$taskNumber'
      fullPath: '/w/$slug/$boardKey/$taskNumber'
      preLoaderRoute: typeof AppWSlugBoardKeyTaskNumberImport
      parentRoute: typeof AppWSlugBoardKeyRouteImport
    }
    '/_app/w/$slug/$boardKey/': {
      id: '/_app/w/$slug/$boardKey/'
      path: '/'
      fullPath: '/w/$slug/$boardKey/'
      preLoaderRoute: typeof AppWSlugBoardKeyIndexImport
      parentRoute: typeof AppWSlugBoardKeyRouteImport
    }
    '/_app/w/$slug/settings/': {
      id: '/_app/w/$slug/settings/'
      path: '/'
      fullPath: '/w/$slug/settings/'
      preLoaderRoute: typeof AppWSlugSettingsIndexImport
      parentRoute: typeof AppWSlugSettingsRouteImport
    }
    '/_app/w/$slug/settings/boards/$boardId': {
      id: '/_app/w/$slug/settings/boards/$boardId'
      path: '/boards/$boardId'
      fullPath: '/w/$slug/settings/boards/$boardId'
      preLoaderRoute: typeof AppWSlugSettingsBoardsBoardIdRouteImport
      parentRoute: typeof AppWSlugSettingsRouteImport
    }
    '/_app/w/$slug/settings/boards/$boardId/lists': {
      id: '/_app/w/$slug/settings/boards/$boardId/lists'
      path: '/lists'
      fullPath: '/w/$slug/settings/boards/$boardId/lists'
      preLoaderRoute: typeof AppWSlugSettingsBoardsBoardIdListsImport
      parentRoute: typeof AppWSlugSettingsBoardsBoardIdRouteImport
    }
    '/_app/w/$slug/settings/boards/$boardId/': {
      id: '/_app/w/$slug/settings/boards/$boardId/'
      path: '/'
      fullPath: '/w/$slug/settings/boards/$boardId/'
      preLoaderRoute: typeof AppWSlugSettingsBoardsBoardIdIndexImport
      parentRoute: typeof AppWSlugSettingsBoardsBoardIdRouteImport
    }
  }
}

// Create and export the route tree

interface AppWSlugBoardKeyRouteRouteChildren {
  AppWSlugBoardKeyTaskNumberRoute: typeof AppWSlugBoardKeyTaskNumberRoute
  AppWSlugBoardKeyIndexRoute: typeof AppWSlugBoardKeyIndexRoute
}

const AppWSlugBoardKeyRouteRouteChildren: AppWSlugBoardKeyRouteRouteChildren = {
  AppWSlugBoardKeyTaskNumberRoute: AppWSlugBoardKeyTaskNumberRoute,
  AppWSlugBoardKeyIndexRoute: AppWSlugBoardKeyIndexRoute,
}

const AppWSlugBoardKeyRouteRouteWithChildren =
  AppWSlugBoardKeyRouteRoute._addFileChildren(
    AppWSlugBoardKeyRouteRouteChildren,
  )

interface AppWSlugSettingsBoardsBoardIdRouteRouteChildren {
  AppWSlugSettingsBoardsBoardIdListsRoute: typeof AppWSlugSettingsBoardsBoardIdListsRoute
  AppWSlugSettingsBoardsBoardIdIndexRoute: typeof AppWSlugSettingsBoardsBoardIdIndexRoute
}

const AppWSlugSettingsBoardsBoardIdRouteRouteChildren: AppWSlugSettingsBoardsBoardIdRouteRouteChildren =
  {
    AppWSlugSettingsBoardsBoardIdListsRoute:
      AppWSlugSettingsBoardsBoardIdListsRoute,
    AppWSlugSettingsBoardsBoardIdIndexRoute:
      AppWSlugSettingsBoardsBoardIdIndexRoute,
  }

const AppWSlugSettingsBoardsBoardIdRouteRouteWithChildren =
  AppWSlugSettingsBoardsBoardIdRouteRoute._addFileChildren(
    AppWSlugSettingsBoardsBoardIdRouteRouteChildren,
  )

interface AppWSlugSettingsRouteRouteChildren {
  AppWSlugSettingsIndexRoute: typeof AppWSlugSettingsIndexRoute
  AppWSlugSettingsBoardsBoardIdRouteRoute: typeof AppWSlugSettingsBoardsBoardIdRouteRouteWithChildren
}

const AppWSlugSettingsRouteRouteChildren: AppWSlugSettingsRouteRouteChildren = {
  AppWSlugSettingsIndexRoute: AppWSlugSettingsIndexRoute,
  AppWSlugSettingsBoardsBoardIdRouteRoute:
    AppWSlugSettingsBoardsBoardIdRouteRouteWithChildren,
}

const AppWSlugSettingsRouteRouteWithChildren =
  AppWSlugSettingsRouteRoute._addFileChildren(
    AppWSlugSettingsRouteRouteChildren,
  )

interface AppWSlugRouteRouteChildren {
  AppWSlugBoardKeyRouteRoute: typeof AppWSlugBoardKeyRouteRouteWithChildren
  AppWSlugSettingsRouteRoute: typeof AppWSlugSettingsRouteRouteWithChildren
  AppWSlugIndexRoute: typeof AppWSlugIndexRoute
}

const AppWSlugRouteRouteChildren: AppWSlugRouteRouteChildren = {
  AppWSlugBoardKeyRouteRoute: AppWSlugBoardKeyRouteRouteWithChildren,
  AppWSlugSettingsRouteRoute: AppWSlugSettingsRouteRouteWithChildren,
  AppWSlugIndexRoute: AppWSlugIndexRoute,
}

const AppWSlugRouteRouteWithChildren = AppWSlugRouteRoute._addFileChildren(
  AppWSlugRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppWSlugRouteRoute: typeof AppWSlugRouteRouteWithChildren
  AppWIndexRoute: typeof AppWIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppWSlugRouteRoute: AppWSlugRouteRouteWithChildren,
  AppWIndexRoute: AppWIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AppRouteRouteWithChildren
  '/': typeof LandingIndexRoute
  '/w/$slug': typeof AppWSlugRouteRouteWithChildren
  '/w': typeof AppWIndexRoute
  '/w/$slug/$boardKey': typeof AppWSlugBoardKeyRouteRouteWithChildren
  '/w/$slug/settings': typeof AppWSlugSettingsRouteRouteWithChildren
  '/w/$slug/': typeof AppWSlugIndexRoute
  '/w/$slug/$boardKey/$taskNumber': typeof AppWSlugBoardKeyTaskNumberRoute
  '/w/$slug/$boardKey/': typeof AppWSlugBoardKeyIndexRoute
  '/w/$slug/settings/': typeof AppWSlugSettingsIndexRoute
  '/w/$slug/settings/boards/$boardId': typeof AppWSlugSettingsBoardsBoardIdRouteRouteWithChildren
  '/w/$slug/settings/boards/$boardId/lists': typeof AppWSlugSettingsBoardsBoardIdListsRoute
  '/w/$slug/settings/boards/$boardId/': typeof AppWSlugSettingsBoardsBoardIdIndexRoute
}

export interface FileRoutesByTo {
  '': typeof AppRouteRouteWithChildren
  '/': typeof LandingIndexRoute
  '/w': typeof AppWIndexRoute
  '/w/$slug': typeof AppWSlugIndexRoute
  '/w/$slug/$boardKey/$taskNumber': typeof AppWSlugBoardKeyTaskNumberRoute
  '/w/$slug/$boardKey': typeof AppWSlugBoardKeyIndexRoute
  '/w/$slug/settings': typeof AppWSlugSettingsIndexRoute
  '/w/$slug/settings/boards/$boardId/lists': typeof AppWSlugSettingsBoardsBoardIdListsRoute
  '/w/$slug/settings/boards/$boardId': typeof AppWSlugSettingsBoardsBoardIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_landing/': typeof LandingIndexRoute
  '/_app/w/$slug': typeof AppWSlugRouteRouteWithChildren
  '/_app/w/': typeof AppWIndexRoute
  '/_app/w/$slug/$boardKey': typeof AppWSlugBoardKeyRouteRouteWithChildren
  '/_app/w/$slug/settings': typeof AppWSlugSettingsRouteRouteWithChildren
  '/_app/w/$slug/': typeof AppWSlugIndexRoute
  '/_app/w/$slug/$boardKey/$taskNumber': typeof AppWSlugBoardKeyTaskNumberRoute
  '/_app/w/$slug/$boardKey/': typeof AppWSlugBoardKeyIndexRoute
  '/_app/w/$slug/settings/': typeof AppWSlugSettingsIndexRoute
  '/_app/w/$slug/settings/boards/$boardId': typeof AppWSlugSettingsBoardsBoardIdRouteRouteWithChildren
  '/_app/w/$slug/settings/boards/$boardId/lists': typeof AppWSlugSettingsBoardsBoardIdListsRoute
  '/_app/w/$slug/settings/boards/$boardId/': typeof AppWSlugSettingsBoardsBoardIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/'
    | '/w/$slug'
    | '/w'
    | '/w/$slug/$boardKey'
    | '/w/$slug/settings'
    | '/w/$slug/'
    | '/w/$slug/$boardKey/$taskNumber'
    | '/w/$slug/$boardKey/'
    | '/w/$slug/settings/'
    | '/w/$slug/settings/boards/$boardId'
    | '/w/$slug/settings/boards/$boardId/lists'
    | '/w/$slug/settings/boards/$boardId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/'
    | '/w'
    | '/w/$slug'
    | '/w/$slug/$boardKey/$taskNumber'
    | '/w/$slug/$boardKey'
    | '/w/$slug/settings'
    | '/w/$slug/settings/boards/$boardId/lists'
    | '/w/$slug/settings/boards/$boardId'
  id:
    | '__root__'
    | '/_app'
    | '/_landing/'
    | '/_app/w/$slug'
    | '/_app/w/'
    | '/_app/w/$slug/$boardKey'
    | '/_app/w/$slug/settings'
    | '/_app/w/$slug/'
    | '/_app/w/$slug/$boardKey/$taskNumber'
    | '/_app/w/$slug/$boardKey/'
    | '/_app/w/$slug/settings/'
    | '/_app/w/$slug/settings/boards/$boardId'
    | '/_app/w/$slug/settings/boards/$boardId/lists'
    | '/_app/w/$slug/settings/boards/$boardId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LandingIndexRoute: typeof LandingIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  LandingIndexRoute: LandingIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/_landing/"
      ]
    },
    "/_app": {
      "filePath": "_app/route.tsx",
      "children": [
        "/_app/w/$slug",
        "/_app/w/"
      ]
    },
    "/_landing/": {
      "filePath": "_landing/index.tsx"
    },
    "/_app/w/$slug": {
      "filePath": "_app/w.$slug/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/w/$slug/$boardKey",
        "/_app/w/$slug/settings",
        "/_app/w/$slug/"
      ]
    },
    "/_app/w/": {
      "filePath": "_app/w.index.tsx",
      "parent": "/_app"
    },
    "/_app/w/$slug/$boardKey": {
      "filePath": "_app/w.$slug/$boardKey/route.tsx",
      "parent": "/_app/w/$slug",
      "children": [
        "/_app/w/$slug/$boardKey/$taskNumber",
        "/_app/w/$slug/$boardKey/"
      ]
    },
    "/_app/w/$slug/settings": {
      "filePath": "_app/w.$slug/settings/route.tsx",
      "parent": "/_app/w/$slug",
      "children": [
        "/_app/w/$slug/settings/",
        "/_app/w/$slug/settings/boards/$boardId"
      ]
    },
    "/_app/w/$slug/": {
      "filePath": "_app/w.$slug/index.tsx",
      "parent": "/_app/w/$slug"
    },
    "/_app/w/$slug/$boardKey/$taskNumber": {
      "filePath": "_app/w.$slug/$boardKey/$taskNumber.tsx",
      "parent": "/_app/w/$slug/$boardKey"
    },
    "/_app/w/$slug/$boardKey/": {
      "filePath": "_app/w.$slug/$boardKey/index.tsx",
      "parent": "/_app/w/$slug/$boardKey"
    },
    "/_app/w/$slug/settings/": {
      "filePath": "_app/w.$slug/settings/index.tsx",
      "parent": "/_app/w/$slug/settings"
    },
    "/_app/w/$slug/settings/boards/$boardId": {
      "filePath": "_app/w.$slug/settings/boards/$boardId/route.tsx",
      "parent": "/_app/w/$slug/settings",
      "children": [
        "/_app/w/$slug/settings/boards/$boardId/lists",
        "/_app/w/$slug/settings/boards/$boardId/"
      ]
    },
    "/_app/w/$slug/settings/boards/$boardId/lists": {
      "filePath": "_app/w.$slug/settings/boards/$boardId/lists.tsx",
      "parent": "/_app/w/$slug/settings/boards/$boardId"
    },
    "/_app/w/$slug/settings/boards/$boardId/": {
      "filePath": "_app/w.$slug/settings/boards/$boardId/index.tsx",
      "parent": "/_app/w/$slug/settings/boards/$boardId"
    }
  }
}
ROUTE_MANIFEST_END */
